import React from "react";
import { MDBPagination, MDBPageItem, MDBPageNav } from "mdbreact";

const Pagination = ({ totalPage, setPage, page }) => (
  <div className="d-flex align-items-center justify-content-center">
    <MDBPagination className="mb-5" color="red">
      <MDBPageItem disabled={page === 1} onClick={() => setPage(page - 1)}>
        <MDBPageNav aria-label="Previous">
          <span aria-hidden="true">Anterior</span>
        </MDBPageNav>
      </MDBPageItem>
      {totalPage &&
        Array.from(Array(+totalPage).keys()).map((currentPage) => (
          <MDBPageItem
            key={currentPage}
            active={currentPage + 1 === page}
            onClick={() => setPage(currentPage + 1)}
          >
            <MDBPageNav>{currentPage + 1}</MDBPageNav>
          </MDBPageItem>
        ))}
      <MDBPageItem
        disabled={totalPage && page === +totalPage}
        onClick={() => setPage(page + 1)}
      >
        <MDBPageNav aria-label="Previous">
          <span aria-hidden="true">Próxima</span>
        </MDBPageNav>
      </MDBPageItem>
    </MDBPagination>
  </div>
);

export default Pagination;
